<div id="inicio" class="card-container col-12 row full-height">
    <div class="col-12 col-lg-8 vygotsky granate comingSoon centrar">
        <p>Lo que un niño puede hacer hoy con ayuda, será capaz de hacerlo por sí mismo mañana</p><br>
        <p>(VYGOTSKY)</p>
    </div>
    <div class="col-12 col-lg-4 centrar separacion">
        <img src="assets/portada.png" alt="image" height="300">
    </div>
</div>